module.exports = __webpack_public_path__ + "static/media/praktikum.06f757ad.jpg";